import React from 'react';
import {Translation} from "react-i18next";
import {Table, Row, Col, DatePicker, Checkbox} from 'antd';
import moment from 'moment';
import {HiOutlineArrowNarrowRight} from 'react-icons/hi';
import styled from 'styled-components';
import utils from "../common/utils";
import {CopyToClipboard} from "react-copy-to-clipboard/lib/Component";
import consts, {BASE_URL} from "../consts";

const {RangePicker} = DatePicker;

const TableWrapper = styled.div`
  margin: 10px;
  box-shadow: 0 5px 5px rgba(211, 211, 211, 0.5);
`;

const RangePickerWrapper = styled.div`
  margin-right: 10px;
`

const dateFormat = 'DD/MM/YYYY';

class CommissionHistoryComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {filterd: false};
  }
  
  componentDidMount() {
    this.props.onFetchCommission();
    this.props.onFetchCommissionByTime([moment().unix() - 2592000, moment().unix()]);
  }
  
  columns = (t, coins) => [
    {
      title: <div style={{marginLeft: 40}}>{t('user.commission_coin')}</div>,
      dataIndex: 'coin_name',
      key: 'coin_name',
      render: (coin) => {
        return <div style={{display: "flex", justifyContent: "center"}}>
          <div style={{width: "45px", textAlign: "left"}}>
            <div style={{
              backgroundImage: `url(${coins[coin]?.icon_image})`,
              height: '25px',
              width: '25px',
              backgroundSize: 'contain',
              marginRight: "20px",
              display: 'block',
              marginTop: 3,
              backgroundRepeat: 'no-repeat'
            }} alt={coin}/>
          
          </div>
          <div style={{
            width: "70px",
            textAlign: "left",
            color: '#000',
            marginTop: '3px',
            fontWeight: 500,
            lineHeight: '28px'
          }}>{coin}</div>
          <div style={{
            width: "230px",
            textAlign: "left",
            fontSize: "16px",
            lineHeight: "28px",
            color: "#76808F",
            marginTop: '3px'
          }}>{coins[coin]?.name ?? ''}</div>
        </div>
      }
    },
    {
      align: "center",
      title: t('user.commission_coin_value'),
      dataIndex: 'value',
      key: 'value',
      width: '30%',
    },
  ];
  
  onPickerChange = (dateStrings) => {
    this.props.onFetchCommissionByTime(dateStrings.map(x => x.unix()))
  }
  
  onFilterChange = (value) => {
    this.setState({filterd: value.target.checked}, () => console.log(value))
  }
  
  render() {
    const { pubkey } = JSON.parse(localStorage.getItem('session') || {})
    let referralLink = `${window.location.protocol}//${window.location.hostname}:${window.location.port}/referral?p=${pubkey}`;

    return (
      <Translation>
        {(t) => {
          return <div className="depositandwithdrawal p-medium user-wallet">
            <div className="depositandwithdrawal-top">
              <div className="mt-small mb-medium" style={{
                width: '600px',
                margin: 'auto',
                marginBottom: '25px',
                border: 'solid 1px',
                borderRadius: '5px',
                padding: '11px',
              }}>
                <div>
                  Mời bạn bè của bạn đến Trustkeys và kiếm <span className="bold">20%</span> phí giao dịch từ họ
                </div>
                <div>
                  <div className="label">
                    Liên kết giới thiệu của bạn:
                    <CopyToClipboard text={referralLink}
                                     onCopy={() => utils.showNotification(t("common.notification"), t("user.deposit.copy"))}>
                      <div
                        className="pointer link bold"
                        style={{
                          display: 'table',
                          textDecoration: 'underline',
                          margin: 'auto',
                        }}
                      >{referralLink}</div>
                    </CopyToClipboard>
                  </div>
                </div>
              </div>
              <Row>
                <Col span={16} className="text-right"
                     style={{
                       lineHeight: '28px'
                     }}
                >
                  <Checkbox style={{color: '#474D57'}} className='text-normal' onChange={this.onFilterChange}>
                    {t('user.account_balance.hide_assets')}
                  </Checkbox>
                </Col>
                <Col span={8} className="text-right">
                  <RangePickerWrapper>
                    <RangePicker className="date-picker" format={dateFormat}
                                 separator={<HiOutlineArrowNarrowRight
                                   style={{fontSize: 11, marginRight: 10, color: 'rgba(0, 0, 0, 0.25)'}}/>}
                                 defaultValue={[moment.unix(moment().unix() - 2592000), moment.unix(moment().unix())]}
                                 disabledDate={(current) => current && current > moment().endOf('day')}
                                 placeholder={[
                                   t('user.deposit_and_withdrawal.deposit_and_withdrawal_start_date'),
                                   t('user.deposit_and_withdrawal.deposit_and_withdrawal_end_date')
                                 ]}
                                 onChange={this.onPickerChange}
                    />
                  </RangePickerWrapper>
                </Col>
                <Col span={12}>
                  <h3 className="text-left ml-small bold">{t('commission.total_receive')}</h3>
                  <TableWrapper>
                    <Table pagination={false} columns={this.columns(t, this.props.coins)}
                           dataSource={
                             this.state.filterd
                               ?
                               this.props.commission.filter((item) => item.value !== 0)
                               :
                               this.props.commission
                           } scroll={{y: window.innerHeight * 0.5}}
            
                    />
                  </TableWrapper>
                </Col>
                <Col span={12}>
                  <h3 className="text-left ml-small bold">{t('commission.total_receive_in_time_duration')}</h3>
                  <TableWrapper>
                    <Table pagination={false} columns={this.columns(t, this.props.coins)}
                           dataSource={this.state.filterd
                             ?
                             this.props.commissionByTime.filter((item) => item.value !== 0)
                             :
                             this.props.commissionByTime}
                           scroll={{y: window.innerHeight * 0.5}}
                    />
                  </TableWrapper>
                </Col>
              </Row>
            </div>
          </div>;
        }
        }
      </Translation>
    );
  }
}

export default CommissionHistoryComponent;
